// @flow
import styled from "styled-components";

export const LinearGradientBackground = styled.div`
  width: 100%;
  min-height: calc((var(--vhw, 1vh) * 100));
  background-image: linear-gradient(340deg, #fff5f1, #f4dfe2);
`;
